// "dd/mm/yyyy"
// "dd/mm/yy"
// "yyyy/mm/dd"
// "hh:mm"
// "hh:mm:ss"
// "dd/mm/yyyy hh:mm"
// FORMDATE_WITH_TIME
// "dd/mmmm/yyyy hh:mm"
// "dd/mmmm/yyyy"
// "mmmm"
// "mmmm/yyyy"

const getDate = (dt, type, divider) => {

  const currentNewDate = new Date();
  const devider = divider ?? "/";
  if(typeof(dt)==='number'){
    var newstr2=dt;
  }else {
    var pattern =  /[\-\.|]/;
    var newstr = dt?.toString()?.replace(pattern, '/');
    var newstr2 = newstr?.replace(pattern, '/');
  }

  let d = new Date(newstr2 ?? currentNewDate);

  const date = new Date(Date.UTC(
    d.getUTCFullYear(),
    d.getUTCMonth(),
    d.getUTCDate(),
    d.getUTCHours(),
    d.getUTCMinutes(),
    d.getUTCSeconds(), ));

  const addNull = (param) => {
    if (param.toString().length > 1) return param;
    else
      return `0${param}`
  }
  const retMonth =(param)=>{
    switch (param) {
      case 0:
       return 'Січня';
       case 1:
       return 'Лютого';
       case 2:
       return 'Березня';
       case 3:
       return 'Квітня';
       case 4:
       return 'Травня';
       case 5:
       return 'Червня';
       case 6:
       return 'Липня';
       case 7:
       return 'Серпня';
       case 8:
       return 'Вересня';
       case 9:
       return 'Жовтня';
       case 10:
       return 'Листопада';
       case 11:
       return 'Грудня';
       default:
         return param;
    }
  }
   const retMonthes =(param)=>{
    switch (param) {
      case 0:
       return 'Січень';
       case 1:
       return 'Лютий';
       case 2:
       return 'Березень';
       case 3:
       return 'Квітень';
       case 4:
       return 'Травень';
       case 5:
       return 'Червень';
       case 6:
       return 'Липень';
       case 7:
       return 'Серпень';
       case 8:
       return 'Вересень';
       case 9:
       return 'Жовтень';
       case 10:
       return 'Листопад';
       case 11:
       return 'Грудень';
       default:
         return param;
    }
  }

  switch (type) {
    case "dd/mm/yyyy":
      return `${addNull(date.getDate())}${devider}${
        addNull(date.getMonth() + 1)
      }${devider}${date.getFullYear()}`;
    case "dd/mm/yy":
      return `${addNull(date.getDate())}${devider}${
        addNull(date.getMonth() + 1)
      }${devider}${date.getYear()-100}`;
    case "yyyy/mm/dd":
      return `${addNull(date.getFullYear())}${devider}${
        addNull(date.getMonth() + 1)
      }${devider}${addNull(date.getDate())}`;
    case "hh:mm":
      return `${addNull(date.getHours())}${devider}${addNull(date.getMinutes())}`;
    case "hh:mm:ss":
      return `${addNull(date.getHours())}${devider}${addNull(date.getMinutes())}${devider}${addNull(date.getSeconds())}`;
    case "dd/mm/yyyy hh:mm":
      return `${addNull(date.getDate())}${devider}${
        addNull(date.getMonth() + 1)
      }${devider}${addNull(date.getFullYear())} ${addNull(date.getHours())}:${addNull(date.getMinutes())}`;
    case 'FORMDATE_WITH_TIME':
      return `${addNull(date.getFullYear())}-${
          addNull(date.getMonth() + 1)
        }-${addNull(date.getDate())}T${addNull(date.getHours())}:${addNull(date.getMinutes())}`
    case "dd/mmmm/yyyy hh:mm":
      return `${addNull(date.getDate())}${devider}${
        retMonth(date.getMonth())
        }${devider}${addNull(date.getFullYear())} ${addNull(date.getHours())}:${addNull(date.getMinutes())}`;
    case "dd/mmmm/yyyy":
      return `${addNull(date.getDate())}${devider}${
        retMonth(date.getMonth())
          }${devider}${date.getFullYear()}`;
    case "mmmm":
      return `${
        retMonthes(date.getMonth())
          }`;
     case "mmmm/yyyy":
      return `${
        retMonthes(date.getMonth())
          }${devider}${date.getFullYear()}`;
     case "yyyy":
      return `${date.getFullYear()}`;
    default:
      return date;
  }
};

export default getDate;